import { render } from "./NavigationFrame.vue?vue&type=template&id=2e795c92&scoped=true"
import script from "./NavigationFrame.vue?vue&type=script&lang=js"
export * from "./NavigationFrame.vue?vue&type=script&lang=js"

import "./NavigationFrame.vue?vue&type=style&index=0&id=2e795c92&lang=css"
import "./NavigationFrame.vue?vue&type=style&index=1&id=2e795c92&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e795c92"]])

export default __exports__